import React from 'react';
import { Card, Button, Icon, Image } from 'semantic-ui-react';

const TeamMember = props => {
  const { member, onDelete } = props;

  return (
    <Card fluid>
      <Card.Content>
        {member.avatar_url && (
          <Image rounded size="mini" floated="left" src={member.avatar_url} />
        )}
        <Card.Header>{member.name}</Card.Header>
        <Card.Meta>
          <Icon name="envelope" /> {member.email}
        </Card.Meta>
      </Card.Content>
      <Card.Content extra>
        <Button.Group size="small">
          <Button negative basic onClick={() => onDelete(member.id)}>
            {member.confirmed ? 'Disable account' : 'Cancel invitation'}
          </Button>
        </Button.Group>
      </Card.Content>
    </Card>
  );
};

export default TeamMember;



// WEBPACK FOOTER //
// ./src/components/TeamMember.js